import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";
import { LOCATION_EXACTNESS_SCOPE } from "@/entities/place";

export const useToggleEventExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();

    return useCallback(
        (newValue: boolean) => {
            const eventValues = getFieldValue("events");
            const valuesCopy = cloneDeep(eventValues);
            Object.values(valuesCopy).forEach((event) => {
                event.instances.forEach((instance) => {
                    // Instances in range mode are detached from MAT — skip them
                    if (instance.isRangeMode) return;

                    if (!newValue) {
                        instance.dateProximity.year = null;
                        instance.dateProximity.month = null;
                        instance.dateProximity.day = null;
                        instance.locationExactness = null;
                        return;
                    }

                    // Should override only nullable values, preserving user-selected proximity
                    if (instance.dateProximity.year === null) {
                        instance.dateProximity.year = 0;
                        instance.dateProximity.month = 0;
                        instance.dateProximity.day = 0;
                    }
                    if (!instance.locationExactness) {
                        instance.locationExactness = LOCATION_EXACTNESS_SCOPE.ThisPlace;
                    }
                });
            });
            setFieldValue("events", valuesCopy);
        },
        [getFieldValue, setFieldValue],
    );
};
